import { DrawerLayoutComponent } from '@ContractBuilder/modules/drawer-layout';
import { create } from 'zustand';

import { useDrawerStore } from './drawer.store';

interface CommentsUIStore {
  activeBlockId: string | undefined;
  setActiveBlockId: (id: string | undefined) => void;
}

export const useCommentsUIStore = create<CommentsUIStore>((set) => ({
  activeBlockId: undefined,
  setActiveBlockId: (id: string | undefined) => {
    set({ activeBlockId: id });

    if (!useDrawerStore.getState().isOpen) {
      useDrawerStore.getState().openDrawer({
        type: DrawerLayoutComponent.Comments,
        props: { blockId: id },
      });
    }
  },
}));
